import { render, staticRenderFns } from "./StepsOptionsAttachPacks.vue?vue&type=template&id=48f90068"
import script from "./StepsOptionsAttachPacks.vue?vue&type=script&lang=js"
export * from "./StepsOptionsAttachPacks.vue?vue&type=script&lang=js"
import style0 from "./StepsOptionsAttachPacks.vue?vue&type=style&index=0&id=48f90068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports